import { useGetCategoryTreesByCountry } from '@/api/gen/category-tree/category-tree.gen';
import { useZepetofulFetchSchoolContent } from '@/api/zepetoful.api';
import { type ReturnUseCachedCategoryInfo } from '@/shared/category/useFetchCategoryInfo';

export const useFetchCategoryInfoByCountryCode = (
  countryCode: string,
): Omit<ReturnUseCachedCategoryInfo, 'countryCode'> => {
  const { data } = useGetCategoryTreesByCountry(countryCode);
  const { data: publishersData } = useZepetofulFetchSchoolContent({
    enabled: countryCode === 'KR',
  });
  return {
    categoryTreeData: data?.data,
    publishersData: publishersData?.publishers?.KR,
  };
};
